(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.before-after-component').forEach(component => {
    const orientation = component.dataset.orientation || 'horizontal';
    const slider = component.querySelector('.slider-line');
    const after = component.querySelector('.after-layer');
    const handle = component.querySelector('.slider-handle');

    let dragging = false;

    const updatePosition = (percent) => {
      percent = Math.max(0, Math.min(100, percent));
      if (orientation === 'vertical') {
        after.style.clipPath = `inset(${percent}% 0 0 0)`;
        slider.style.top = `${percent}%`;
      } else {
        after.style.clipPath = `inset(0 0 0 ${percent}%)`;
        slider.style.left = `${percent}%`;
      }
    };

    const startDrag = (e) => {
      // Don't start drag if clicking on a label link
      if (e.target.closest('.before-label-wrapper, .after-label-wrapper')) return;
      
      e.preventDefault();
      dragging = true;
      document.addEventListener('mousemove', dragMove);
      document.addEventListener('mouseup', stopDrag);
      document.addEventListener('touchmove', dragMove, { passive: false });
      document.addEventListener('touchend', stopDrag);
    };

    const stopDrag = () => {
      dragging = false;
      document.removeEventListener('mousemove', dragMove);
      document.removeEventListener('mouseup', stopDrag);
      document.removeEventListener('touchmove', dragMove);
      document.removeEventListener('touchend', stopDrag);
    };

    const dragMove = (e) => {
      if (!dragging) return;
      e.preventDefault();
      const rect = component.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      let percent = orientation === 'vertical'
        ? ((clientY - rect.top) / rect.height) * 100
        : ((clientX - rect.left) / rect.width) * 100;

      updatePosition(percent);
    };

    slider.addEventListener('mousedown', startDrag);
    slider.addEventListener('touchstart', startDrag, { passive: false });

    component.addEventListener('mousedown', (e) => {
      if (e.target === slider || e.target.closest('.slider-handle') || e.target.closest('.before-label-wrapper, .after-label-wrapper')) return;
      startDrag(e);
      dragMove(e);
    });

    const start = parseFloat(component.dataset.start) || 50;
    updatePosition(start);
  });
});

  } catch(e) { console.error(e); }
})();
})();
